import * as React from 'react'
import OnboardingLayout from './components/OnboardingLayout/OnboardingLayout'
import { useCallback } from 'react'
import { useAppDispatch } from '../../store/utils/hooks'
import { actionResetUserState } from '../../store/slices/user/userSlice'
import { Outlet, useNavigate } from 'react-router-dom'
import { userSignOut } from '../../utils/Firebase/methods'
import { LOGIN_PATH } from '../../routes/LoginRoutes'

export default function OnboardingPage() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()

	const signOut = useCallback(async () => {
		await userSignOut()
		dispatch(actionResetUserState())
	}, [dispatch])

	const navigateLogin = useCallback(async () => {
		await signOut()
		navigate(LOGIN_PATH)
	}, [navigate, signOut])

	return (
		<OnboardingLayout navigateLogin={navigateLogin}>
			<Outlet />
		</OnboardingLayout>
	)
}
